/*
 * @Author       : Zhelin Cheng
 * @Date         : 2021-10-12 14:42:01
 * @LastEditors  : Zhelin Cheng
 * @LastEditTime : 2021-10-12 14:46:09
 * @FilePath     : /marketing-introduce-ssr/project.config.js
 * @Description  : 未添加文件描述
 */

const envDebug = process.env.ENV_DEBUG; // 本地调试
const envName = process.env.ENV_NAME || 'dev'; // 环境变量
const appName = process.env.APP_NAME || '';
const sentryDsn = 'https://dc91a2d804bc4bc380e8d9f6a98300fd@sentry.tinman.cn/50';

module.exports = {
  envDebug,
  envName,
  sentryDsn,
  appName
};
